<template>
    <input
        type="file"
        :v-model="csvFile"
        @change="handleCsvFile"
    />
</template>

<script>
import Vue from 'vue';

export default {
    name: 'ssn-decrypt',
    data () {
        return {
            partner: 'Storebrand',
            csvFile: null,
            fromDate: null,
            toDate: null,
            loading: false,
            snackbar: {
                show: false,
                timeout: 6000,
                text: ''
            }
        };
    },
    computed: {
        minDate () {
            return this.fromDate;
        }
    },
    methods: {
        async handleCsvFile (event) {
            console.log(event.target.files[0]);
            let formData = new FormData();
            formData.append('csv_file', event.target.files[0]);
            let response = await Vue.axios.post('/decrypt-ssn', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            const blob = new Blob([response.data], { type: 'text/csv' });

            // Create a link element
            const link = document.createElement('a');

            // Set the href attribute with the Blob data
            link.href = window.URL.createObjectURL(blob);

            // Set the download attribute to force download
            link.download = 'your_filename.csv';

            // Append the link to the document body
            document.body.appendChild(link);

            // Trigger a click on the link to start the download
            link.click();

            // Remove the link from the document
            document.body.removeChild(link);
        }
    }
};
</script>

<style lang="scss">
.v-date-picker-table .v-btn {
    font-size: 12px !important;
    font-weight: 500 !important;
    height: 32px !important;
    border-radius: 50% !important;
    text-transform: uppercase !important;
}
</style>
